import { ca } from '@cian/analytics';

type TrackNavigationEventProps = {
  category: 'CompareJK' | 'Compare';
  action: 'to_listingjk' | 'to_flats';
  pageType: 'ListingCompareJK' | 'ListingCompare';
};

function trackNavigationEvent({ category, action, pageType }: TrackNavigationEventProps) {
  return ca('eventSite', {
    name: 'oldevent',
    category: category,
    action: action,
    label: 'empty_list',
    page: {
      siteType: 'desktop',
      pageType: pageType,
    },
  });
}

export function trackNavigationToFlats() {
  trackNavigationEvent({ category: 'Compare', action: 'to_flats', pageType: 'ListingCompare' });
}

export function trackNavigationToJK() {
  trackNavigationEvent({ category: 'CompareJK', action: 'to_listingjk', pageType: 'ListingCompareJK' });
}
